// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story"}[chunkId] || chunkId) + "-" + {"2813":"1070a32283c6c0647292","3093":"8c3760860e4baea752a0","3180":"b4439e63277f46397e76"}[chunkId] + ".css";
};